import React, { useState } from 'react';
import { TreatmentApproach } from '../../pages/patient/CreationProcess/treatmentDetails';
import VideoPlayerModal from '../modals/VideoPlayerModal';

interface ApproachCardProps {
    approach: TreatmentApproach;
    isSelected: boolean;
    onSelect: () => void;
}

const placeholderImage =
    'https://images.unsplash.com/photo-1599496336901-2b36a83637e6?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

const getYouTubeThumbnail = (url: string) => {
    try {
        const urlObj = new URL(url);
        const videoId = urlObj.searchParams.get('v');
        if (urlObj.hostname === 'youtu.be' && urlObj.pathname) {
            return `https://img.youtube.com/vi/${urlObj.pathname.substring(1)}/0.jpg`;
        }
        if (videoId) {
            return `https://img.youtube.com/vi/${videoId}/0.jpg`;
        }
    } catch (error) {
        console.error('Invalid video URL:', url);
    }
    return placeholderImage;
};

const ApproachCard: React.FC<ApproachCardProps> = ({ approach, isSelected, onSelect }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const videoThumbnail = getYouTubeThumbnail(approach.link);

    const handlePreviewClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div
                className={`p-6 rounded-lg border-2 cursor-pointer w-full flex items-start gap-6 ${
                    isSelected ? 'border-yellow-400 bg-yellow-50' : 'border-gray-200 bg-white'
                }`}
                onClick={onSelect}
            >
                <input
                    type="radio"
                    name="approach"
                    checked={isSelected}
                    readOnly
                    className="mt-1 h-5 w-5 flex-shrink-0"
                    style={{ accentColor: '#000000' }}
                />
                <div className="flex-1 flex flex-col gap-2">
                    <h3 className="text-lg font-bold">{approach.title}</h3>
                    <ul className=" mt-2 list-disc list-inside px-2 space-y-3 text-sm text-[#6B7280]">
                        {Object.keys(approach.benefits).map((benefit: string) => (
                            <li key={`b-${benefit}`}>
                                <span className="font-bold">{benefit} : </span>
                                <span className="font-normal">{approach.benefits[benefit]}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="w-[320px] h-[180px] flex-shrink-0 relative">
                    <img
                        src={videoThumbnail}
                        alt={`Preview for ${approach.title}`}
                        className="rounded-lg w-full h-full object-cover"
                    />
                    <div
                        className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 rounded-lg cursor-pointer"
                        onClick={handlePreviewClick}
                    >
                        <svg
                            className="w-12 h-12 text-white"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                                clipRule="evenodd"
                            ></path>
                        </svg>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center h-full">
                <VideoPlayerModal
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    title={approach.title}
                    videoUrl={approach.link}
                />
            </div>
        </>
    );
};

export default ApproachCard;
